<script setup lang="ts">

import ImgMain from '~/components/shared/Img/ImgMain.vue';

type Props = {
    collectionName?: string;
    collectionImg?: string;
    nftAddress?: AppWTFNft['address'];
};
const { collectionName, collectionImg, nftAddress } = defineProps<Props>();
</script>

<template>
  <div class="display-flex align-items-center gap-12">
    <div class="name-collection-image">
      <ImgMain :alt="collectionName"
               :src="collectionImg"
               densities="x1 x2"
               loading="lazy"
               quality="90"
      />
    </div>

    <p class="compact-400-accent">
      {{ collectionName }} <span class="color-text-grey compact-400-default">by</span>
      {{ toShortAddress(nftAddress || '') }}
    </p>
  </div>
</template>
<style scoped lang="scss">
.name-collection-image {
  width: 28px;
  height: 28px;
  border: var(--image-paranja-stroke, 1px) solid var(--border-paranja, rgb(255 255 255 / 20%));
  border-radius: var(--control-300-radius, 2px);
}
</style>
